module.exports = __webpack_public_path__ + "front/img/i1.dfc7bc67.png";